import $ from "jquery";
import Cookie from "js-cookie";
// since we are embedding into an ios app, we need to be able to make sure
// relative urls go to the right place, even when running on the file protocol
// (file://). This method will detect when that happens, and append babbl the
// url if needed
//
// It will also pass the signed user_id to the server as a parameter, this is
// required because cookies are not always passed through from file:// to CORS
// requests properly (even when withAuthentication is turned on)
const lurl = (u) => {
    if (!$("body").hasClass("is-local")) {
        return u;
    }
    else {
        const signed_user_id = Cookie.get("signed_user_id");
        if (signed_user_id) {
            u += (u.includes("?") ? "&" : "?") + `suk=${signed_user_id}`;
        }
        return `https://babbl.xyz${u}`;
    }
};
export default lurl;
